import { render, staticRenderFns } from "./markDrawer.vue?vue&type=template&id=2d54bae9&scoped=true"
import script from "./markDrawer.vue?vue&type=script&lang=js"
export * from "./markDrawer.vue?vue&type=script&lang=js"
import style0 from "./markDrawer.vue?vue&type=style&index=0&id=2d54bae9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d54bae9",
  null
  
)

export default component.exports